<template>
  <div
    :class="['list-item', { opened: isOpened }]"
  >
    <div
      ref="title"
      class="title"
      @click="openList(list.name)"
    >
      <span>{{ list.name }}</span>
      <div>
        <chevron-animated :reverse="isOpened" />
      </div>
    </div>
    <div
      v-if="list.items && list.items.length"
      ref="list"
      class="list"
    >
      <a
        v-for="(item, i) in list.items[0]"
        :key="i"
        :href="item.url"
        @click.prevent="$emit('link-click', item.url)"
        v-text="item.name"
      />
    </div>
  </div>
</template>

<script>
import ChevronAnimated from '@icons/chevron-animated.vue';

export default {
  name: 'list-item',

  components: {
    ChevronAnimated,
  },

  props: {
    list: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpened: false,
    };
  },

  methods: {
    openList(name) {
      this.$emit('section-toggle', name);
      this.isOpened = !this.isOpened;
    },
  },
};
</script>

<style lang="scss">
.list-item {
  width: 100%;
  max-height: 48px;
  overflow: hidden;
  border-bottom: 1px solid $gray_lu;
  transition: .3s max-height ease;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid $gray_lu;

    & > span {
      color: $black;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
    }

    & > div {
      width: 16px;
      height: 16px;
      color: $gray_lu;
    }
  }

  .list {
    display: flex;
    flex-direction: column;

    & > a {
      height: 48px;
      padding: 12px 16px;
      font-size: 14px;
      line-height: 24px;
      color: $gray;
      border-bottom: 1px solid $gray_lu;
    }
  }

  &.opened {
    max-height: 480px;
    border-bottom: none;
  }
}

@include breakpoint("tablet") {
  .list-item {
    .title {
      padding: 12px 32px;
    }

    .list {
      & > a {
        padding: 12px 32px;
      }
    }
  }
}

@include breakpoint("desktop") {
  .list-item {
    max-height: none;
    padding: 0;
    border-bottom: none;
    flex: 1 0 calc(33.33% - 42px);

    .lists {
      margin-right: 24px;

      & > div {
        flex: 0 0 calc((100% / 12) * 3.7);
      }
    }

    .title {
      padding: 0;
      pointer-events: none;
      border-bottom: none;
      & > span {
        line-height: 20px;
      }
      & > div {
        display: none;
      }
    }

    .list {
      margin-top: 16px;

      & > a {
        height: auto;
        margin-top: 10px;
        padding: 0;
        color: $gray;
        font-size: 16px;
        line-height: 24px;
        border-bottom: none;

        &:first-of-type {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
